
import { t } from '@/i18n'
const FLIGHT_COMMAND_CONFIRMATIONS = {
  land: { title: '降落操作', message: '确认让当前飞机降落？请确认降落区域安全。', button: '确认降落', command: '{landMode:1}', description: '降落' },
  rtl: { title: '返航操作', message: '确认让当前飞机返航？请确认返航路径和起飞点安全。', button: '确认返航', command: '{rtlMode:1}', description: '返航' },
  resume: { title: '复航操作', message: '确认让当前飞机继续执行航线？', button: '确认复航', command: '{autoMode:1}', description: '继续执行航线' }
}

// 危险飞行指令共用同一套确认文案和交互，避免不同操作入口行为不一致。
export function confirmFlightCommand (vm, type, execute) {
  const action = FLIGHT_COMMAND_CONFIRMATIONS[type]
  if (!vm || !action || typeof execute !== 'function') return
  vm.$confirm(t(action.message), t(action.title), {
    confirmButtonText: t(action.button),
    cancelButtonText: t('取消'),
    type: 'warning'
  }).then(() => execute(action.command, action.description)).catch(() => {})
}
